import type { SvgIconProps } from '@mui/material/SvgIcon';
import { ComponentType, useEffect, useState } from 'react';

import MaterialIcon from './MaterialIcon';
import WrenchIcon from './Wrench';
import { getCachedIcon, loadIcon } from './iconLoaders';
import { materialIconIdFromAttr } from './materialIconRegistry';

;

export type IconProps = SvgIconProps & {
  icon: string;
};

const Icon = ({ icon, ...props }: IconProps) => {
  const materialIconId = materialIconIdFromAttr(icon);

  const [ResolvedIcon, setResolvedIcon] = useState<ComponentType<SvgIconProps> | null>(() =>
    materialIconId ? null : (getCachedIcon(icon) ?? null),
  );

  useEffect(() => {
    if (materialIconId) return;

    const cached = getCachedIcon(icon);
    if (cached) {
      setResolvedIcon(() => cached);
      return;
    }

    let cancelled = false;
    setResolvedIcon(null);

    void loadIcon(icon).then(Loaded => {
      if (cancelled) return;
      setResolvedIcon(() => Loaded ?? WrenchIcon);
    });

    return () => {
      cancelled = true;
    };
  }, [icon, materialIconId]);

  if (materialIconId) {
    return <MaterialIcon iconId={materialIconId} {...props} />;
  }

  const Component = ResolvedIcon ?? WrenchIcon;
  return <Component {...props} />;
};
export default Icon;
